import { render, staticRenderFns } from "./PartnerOrderRequestList.vue?vue&type=template&id=96790b22&"
import script from "./PartnerOrderRequestList.vue?vue&type=script&lang=js&"
export * from "./PartnerOrderRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports